// extracted by mini-css-extract-plugin
export var card = "_j9-5";
export var cardSelected = "_j9-4";
export var image = "_j9-3";
export var modal = "_j9-0";
export var modalContent = "_j9-1";
export var table = "_j9-2";